import { apiSlice } from "../api/apiSlice";

export const quizzesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getQuizzes: builder.query({
      query: () => "/quizzes",
    }),
    getQuizById: builder.query({
      query: (quizId) => `/quizzes/${quizId}`,
    }),
    getQuiz: builder.query({
      query: (videoId) => `/quizzes?video_id=${videoId}`,
    }),
    createQuiz: builder.mutation({
      query: (data) => ({
        url: "/quizzes",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const result = await queryFulfilled;
          if (result.data.id) {
            // passimistically update quizzes
            dispatch(
              apiSlice.util.updateQueryData(
                "getQuizzes",
                undefined,
                (draft) => {
                  draft.push(result.data);
                }
              )
            );
          }
        } catch (err) {
          console.log(err);
        }
      },
    }),
    updateQuiz: builder.mutation({
      query: ({ id, quizData }) => ({
        url: `/quizzes/${id}`,
        method: "PATCH",
        body: quizData,
      }),
      async onQueryStarted({ id, quizData }, { dispatch, queryFulfilled }) {
        try {
          const result = await queryFulfilled;
          if (result.data.id) {
            // passimistically update quizzes
            dispatch(
              apiSlice.util.updateQueryData(
                "getQuizzes",
                undefined,
                (draft) => {
                  const updatedQuiz = draft.find((quiz) => quiz.id === id);
                  updatedQuiz.title = quizData.title;
                  updatedQuiz.description = quizData.description;
                  updatedQuiz.video_id = quizData.video_id;
                  updatedQuiz.questions = quizData.questions;
                }
              )
            );
            // passimistically update quiz
            dispatch(
              apiSlice.util.updateQueryData("getQuizById", id, (draft) => {
                draft.title = quizData.title;
                draft.description = quizData.description;
                draft.video_id = quizData.video_id;
                draft.questions = quizData.questions;
              })
            );
          }
        } catch (err) {
          console.log(err);
        }
      },
    }),
    deleteQuiz: builder.mutation({
      query: (quizId) => ({
        url: `/quizzes/${quizId}`,
        method: "DELETE",
      }),
      async onQueryStarted(quizId, { dispatch, queryFulfilled }) {
        try {
          const result = await queryFulfilled;
          if (result?.meta?.response?.status === 200) {
            // passimistically update quizzes
            dispatch(
              apiSlice.util.updateQueryData(
                "getQuizzes",
                undefined,
                (draft) => {
                  const deletedQuiz = draft.filter(
                    (quiz) => quiz.id !== quizId
                  );
                  return deletedQuiz;
                }
              )
            );
          }
        } catch (err) {
          console.log(err);
        }
      },
    }),
  }),
});

export const {
  useGetQuizzesQuery,
  useGetQuizQuery,
  useGetQuizByIdQuery,
  useCreateQuizMutation,
  useUpdateQuizMutation,
  useDeleteQuizMutation,
} = quizzesApi;
